import { jsx as _jsx } from "react/jsx-runtime";
import ExamLayout from './ExamLayout';
import ExamResumeScreen from './ExamResumeScreen';
import ExamRulesScreen from './ExamRulesScreen';
import ExamFinishedScreen from './ExamFinishedScreen';
import ExamQuestionScreen from './ExamQuestionScreen';
import ExamLoadingScreen from './ExamLoadingScreen';
import ExamErrorScreen from './ExamErrorScreen';
import ExamAccessIssueScreen from './ExamAccessIssueScreen';
import { useAllProgress } from '../../userProgress';
import { useMostRecentExamAttempt } from '../examsQueries';
import { useCanDoAllTrackPracticalExercises } from '../../tracks';
import { useExamRulesState, withExamContextProvider } from '../examsStores';

const Exam = ({
  trackId
}) => {
  const {
    showExamRules
  } = useExamRulesState();
  const {
    allProgressLoading,
    allProgressError
  } = useAllProgress();
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(Number(trackId));
  const {
    canDoAllTrackPracticalExercises,
    canDoAllTrackPracticalExercisesLoading,
    canDoAllTrackPractcialExercisesError
  } = useCanDoAllTrackPracticalExercises(trackId.toString());
  const isLoadingCombined = mostRecentExamAttemptLoading || canDoAllTrackPracticalExercisesLoading || allProgressLoading;
  const errorCombined = mostRecentExamAttemptError || canDoAllTrackPractcialExercisesError || allProgressError;

  if (isLoadingCombined) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamLoadingScreen, {})
    });
  }

  if (errorCombined) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamErrorScreen, {
        error: errorCombined
      })
    });
  }

  if (!canDoAllTrackPracticalExercises) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamAccessIssueScreen, {})
    });
  }

  if (!mostRecentExamAttempt || showExamRules) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamRulesScreen, {
        trackId: Number(trackId)
      })
    });
  }

  if (mostRecentExamAttempt && mostRecentExamAttempt.finished) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamFinishedScreen, {
        trackId: Number(trackId)
      })
    });
  }

  if (mostRecentExamAttempt && !mostRecentExamAttempt.questions.length) {
    return /*#__PURE__*/_jsx(ExamLayout, {
      children: /*#__PURE__*/_jsx(ExamResumeScreen, {
        trackId: Number(trackId)
      })
    });
  }

  return /*#__PURE__*/_jsx(ExamLayout, {
    children: /*#__PURE__*/_jsx(ExamQuestionScreen, {
      trackId: Number(trackId)
    })
  });
};

export default withExamContextProvider(Exam);